import { MonitoringGateway } from './monitoring-gateway.interface';

export const initMonitoringAPI = (
  apiSlice: any,
  gateway: MonitoringGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Monitoring'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        ping: builder.mutation({
          query: gateway.ping,
        }),
        getAllPingByRoleAndUsername: builder.query({
          query: gateway.getAllPingByRoleAndUsername,
        }),
      }),
      overrideExisting: false,
    });
};

export interface MonitoringSliceType {
  usePingMutation: Function;
  useGetAllPingByRoleAndUsernameQuery: Function;
}
